<template>
    <router-view />
</template>

<script>
export default {
    name: 'ServiceManagementWrapper',
}
</script>
